(function () {
  angular.module('MktzapApp.Factories')
    .factory('KnowledgeBaseService', KnowledgeBaseService);

  KnowledgeBaseService.$inject = ['$resource'];

  function KnowledgeBaseService ($resource) {
    return $resource(apiUrl + '/knowledge-base/:id', { id: '@id' }, {
      paged: { url: apiUrl + '/knowledge-base/paged', method: 'GET', params: {}, isArray: false },
      save: { url: apiUrl + '/knowledge-base/save', method: 'POST', params: {}, isArray: false },
      delete: { url: apiUrl + '/knowledge-base/delete', method: 'DELETE', params: {}, isArray: false },
      update: { url: apiUrl + '/knowledge-base/update', method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      knowledgeBaseMoreUsed: { url: apiUrl + '/knowledge-base/most-used', method: 'GET', params: {}, isArray: true },
      searchKnowledgeBase: { url: apiUrl + '/knowledge-base/search-knowledge-base', method: 'GET', params: {}, isArray: true },
      increments: { url: apiUrl + '/knowledge-base/increments-total', method: 'POST', params: {}, isArray: false },
      getTagsAutoComplete: { url: apiUrl + '/knowledge-base/get-tags-auto-complete', method: 'GET', params: {}, isArray: true }
    });
  }
})();
